import React, { useMemo } from 'react'
import { useStatsJoueursDataContext } from '../../../contexts/StatsJoueursDataContext'
import { StatsJoueurDetailRow } from './StatsJoueurDetailRow'
import { StatsJoueurChart } from './StatsJoueurChart'
import type { JoueurType, RowDetailsEntry } from '../data'
import { Spinner } from '../../../components/Spinner'
import styles from './styles.module.scss'

const chartDataMapStrategies: { [x in JoueurType]: (v: RowDetailsEntry) => number } = {
    joueur_de_champ: (x) => +x.buts,
    gardien: (x) => +x.arrets,
}

export const StatsJoueurDetails = ({ individuId }: { individuId: string }) => {
    const { fetchingDetails, statsJoueursDetails, joueurType } = useStatsJoueursDataContext()

    const details = useMemo(
        () => statsJoueursDetails[individuId] ?? [], // todo: may handle error (null)
        [individuId, statsJoueursDetails],
    )

    const isFetchingDetails = fetchingDetails === individuId

    const chartData = useMemo(
        () => details.map(chartDataMapStrategies[joueurType]),
        [details, joueurType],
    )

    // todo: fade in fade out transition when state changes
    if (isFetchingDetails)
        return (
            <div className={styles.loading}>
                <Spinner className={styles.spinner} /> Chargement des données...
            </div>
        )

    // todo: sometimes this is displayed before showing details
    if (!details.length) return <div className={styles.noData}>Pas de données</div>

    return (
        <div className={styles.details}>
            <div className={styles.table}>
                {details.map((x) => (
                    <StatsJoueurDetailRow key={x.id} data={x} />
                ))}
            </div>
            <div className={styles.chart}>
                <StatsJoueurChart data={chartData} />
            </div>
        </div>
    )
}
